// HTTP body keys
export const CLIENT_KEY: string = 'client';
export const GOOGLE_MERCHANT_API_VERSION_KEY: string = 'api_version';

// HTTP body client values
export const GOOGLE_PRODUCT_FEED_CLIENT_VALUE: string = 'GoogleProductFeed';
export const TIKTOK_PRODUCT_FEED_CLIENT_VALUE: string = 'TikTokProductFeedv2';

// HTTP body API version value
export const GOOGLE_MERCHANT_API_VERSION_VALUE: string = 'merchant-api';
